//supported Languages needs a new enum
export const availableLocales = {
  EN: "en-US",
  DE: "de-DE",
  FR: "fr-FR",
};

//selection-example
export const LOCALES = [
  { value: availableLocales.DE, caption: "Deutsch" },
  { value: availableLocales.FR, caption: "Français" },
];
